import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  Input,
} from '@angular/core';
import { DiscountLabelModule } from '@epicuro-next/ataraxia/discount-label';
import { ImageModule, IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { ProductCardTitleComponent } from '@epicuro-next/ataraxia/product-card';
import { ProductPriceModule } from '@epicuro-next/ataraxia/product-price';
import {
  ProductIdPipe,
  ProductTitleModule,
} from '@epicuro-next/ataraxia/product-title';
import { withPcardSettingStoreFeature } from '@epicuro-next/state/p-basket-state';
import { signalStore } from '@ngrx/signals';
import {
  FilterLabelsByNamePipe,
  ProductLabelLocation,
  ProductLabelsComponent,
} from 'ataraxia-product-labels';
import { Product } from 'graphql-api/gql-api-interfaces';

// tslint:disable-next-line:variable-name
const PCardSettingStore = signalStore(withPcardSettingStoreFeature());

@Component({
  selector: 'atx-horizontal-product-v2',
  imports: [
    CommonModule,
    DiscountLabelModule,
    FilterLabelsByNamePipe,
    ImageModule,
    ProductIdPipe,
    ProductLabelsComponent,
    ProductCardTitleComponent,
    ProductTitleModule,
    ProductPriceModule,
  ],
  templateUrl: './horizontal-product-v2.component.html',
  styleUrl: './horizontal-product-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PCardSettingStore],
})
export class HorizontalProductV2Component {
  @Input({ required: true })
  public product!: Product;

  public shownLabelsLimit = input(2);

  private readonly pcardStore = inject(PCardSettingStore);

  public readonly imageMaxSize = IMAGE_MAX_SIZES.AVATAR;
  public readonly labelsLocation = ProductLabelLocation.All;

  public readonly showWspdPrice = this.pcardStore.showWspdPrice;

  public readonly showWholeSalePrices = this.pcardStore.showWholeSalePrices;

  public readonly showMarkupPrice = this.pcardStore.showMarkupPrice;

  public readonly productIdAdditionalPrefixRexExp =
    this.pcardStore.productIdAdditionalPrefixRexExp;

  public readonly titleFields = this.pcardStore.titleFields;

  public readonly idFields = this.pcardStore.idFields;
}
